import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { PromotionReport } from "../../report/components/PromotionReport";
import { getCookie } from "../../slidebar/components/DarkMode";

export const PromotionReportModal = ({
  showPromotionReport,
  setShowPromotionReport,
}) => {
  const intl = useIntl();
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const handleClose = () => {
    setShowPromotionReport(undefined);
  };

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  return (
    <>
      <Modal
        show={!!showPromotionReport}
        onHide={handleClose}
        centered
        size="xl"
        data-bs-theme={mode}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "promotionReport",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {showPromotionReport && (
            <PromotionReport promotionId={showPromotionReport} />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};
